import styled from 'styled-components';
import { Col, Row } from 'react-bootstrap';
import { mediaBreakpointDown, mediaBreakpointUp } from 'utils/styledCssHelpers';
import DotSVG from 'components/DotSVG';

export const SSection = styled.section`
  margin: ${props => props.margin || 'unset'};
  padding: ${props => (props.padding ? '5em 0' : 'unset')};
  position: relative;
  overflow: ${props => (props.overflow ? 'hidden' : 'unset')};
  z-index: 0;
  background: ${props =>
    !props.noBackground &&
    (props.mode == 'dark'
      ? props.theme.colors.main
      : props.theme.colors.bg_grey)};
`;

export const SCol = styled(Col)`
  position: ${props => props.position || 'relative'}; ;
`;

export const SRow = styled(Row)`
  //position: ${props => props.position || 'relative'}; ;
  //flex-direction: column;
`;

export const SSVGHolder = styled.div`
  position: absolute;
  top: 650px;
  left: 50px;
  height: 100px;

  ${mediaBreakpointDown(
    'xl',
    `
    left: 50px;
    top: 530px;
    
  `,
  )};

  & svg {
    ${mediaBreakpointDown(
      'xl',
      `
    left:  0px;
    top:  0px;
    
  `,
    )};

    ${mediaBreakpointDown(
      'lg',
      `
    display: none;
  `,
    )};
  }
`;

export const SSVGHolderPhotography = styled.div`
  position: absolute;
  top: 20px;
  left: 790px;
  height: 100px;
  z-index: 5;

  ${mediaBreakpointUp(
    'xxl',
    `
    left:  795px;
    
  `,
  )};
  ${mediaBreakpointDown(
    'xl',
    `
    left:  610px;
  `,
  )};

  ${mediaBreakpointDown(
    'lg',
    `
    display: none;
  `,
  )};
  & svg {
  }
`;

export const SDotSVGHolder = styled.div`
  ${mediaBreakpointDown(
    'xl',
    `
    display: none;
  `,
  )};
`;

export const SDotSVG = styled(DotSVG)`
  overflow: hidden;
  width: 50%;
  transform: translateY(470px) !important;
`;
